import { render, staticRenderFns } from "./AvailabilityForm.vue?vue&type=template&id=5c6550f6&scoped=true&"
import script from "./AvailabilityForm.vue?vue&type=script&lang=js&"
export * from "./AvailabilityForm.vue?vue&type=script&lang=js&"
import style0 from "./AvailabilityForm.vue?vue&type=style&index=0&id=5c6550f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6550f6",
  null
  
)

export default component.exports